<div class="popup secondary">
  <app-loading *ngIf="loading" width="30px" [show]="loading"> </app-loading>
  <div class="popup-content" *ngIf="!loading">
    <div class="header">
      <h5>
        <span>{{ 'From' | translate }}</span
        >{{ title }}
      </h5>
      <p
        class="extra"
        [class.has-visits-visitors]="
          getExtra().length === 2 && isVisitsAvailable
        "
        *ngFor="let extra of getExtra()"
      >
        {{ extra.value | hideZeroValues : '1.0-0' }}
        <span>{{ extra.label | translate }}</span>
      </p>
    </div>
    <div class="tab-panel">
      <ul class="tab-heading" *ngIf="tabs.length > 1">
        <li
          *ngFor="let tab of tabs"
          (click)="currentTab = tab.key"
          [class.selected]="currentTab === tab.key"
          [class.compareMode]="compareMode"
        >
          {{ tab.title | translate }}
        </li>
      </ul>
      <div class="tab-content" *ngIf="tabs.length > 0">
        <app-bars-widget
          class="dark lowercase"
          [data]="getStats()"
          [highlight]="getSelectedStats()"
          [showTooltip]="false"
          [isMultiple]="compareMode"
          [isCompact]="true"
        >
        </app-bars-widget>
      </div>
    </div>
  </div>
</div>
